import React, { useEffect } from 'react';
import { compose } from 'redux';
import { FormMessageHOC } from 'common';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import BaseButton from '../../../BaseButton';
import { SelectFormField, TextAreaField } from '../../index';
import { staticStyles } from './style';
import { sendMessageByWazzup, getWazzupChannels } from '../../../../wazzup/_redux/actions';

const CrmSendMessageByWazzupForm = ({
  handleSubmit,
  submitting,
  invalid,
  error,
  userName,
  contactId,
  sendMessageByWazzup,
  phone,
  channelsOptions,
  getWazzupChannels,
}) => {
  useEffect(() => {
    getWazzupChannels();
  }, [getWazzupChannels]);

  const submit = handleSubmit(values => {
    const selectedChannel = channelsOptions.find(option => option.value === values.chartType);

    if (!selectedChannel) {
      return;
    }

    sendMessageByWazzup({
      contactId,
      channelId: selectedChannel.value,
      chatType: selectedChannel.transport,
      text: values.message,
      phone,
    });
  });

  return (
    <form className="CrmSendMessageByWazzupForm" onSubmit={submit}>
      <FormattedMessage id="byWazzup">
        {txt => <span className="CrmSendMessageByWazzupForm__byWazzup">{txt}</span>}
      </FormattedMessage>
      <span className="CrmSendMessageByWazzupForm__sendTo">To: {userName}</span>
      <div className="CrmSendMessageByWazzupForm__inputs-inner">
        <Field
          name="chartType"
          component={SelectFormField}
          validate={[required()]}
          options={channelsOptions.map(option => ({ value: option.value, label: option.label }))}
          disabled={submitting}
          labelTextId="chatType"
          placeholder="Choose a channel"
        />
        <Field
          name="message"
          component={TextAreaField}
          validate={[required()]}
          disabled={submitting}
          placeholder="Enter message"
          rows="5"
          cols="5"
          textId="justMessage"
        />
      </div>

      <BaseButton type="submit" textId="justSend" maxContent disabled={invalid || submitting} />

      {error && <strong className="formError">{error}</strong>}

      <style jsx global>
        {staticStyles}
      </style>
    </form>
  );
};

CrmSendMessageByWazzupForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  userName: PropTypes.string.isRequired,
  contactId: PropTypes.number.isRequired,
  sendMessageByWazzup: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  channelsOptions: PropTypes.array.isRequired,
  getWazzupChannels: PropTypes.func.isRequired,
};

CrmSendMessageByWazzupForm.defaultProps = {
  error: '',
};

export default compose(
  FormMessageHOC,
  connect(
    state => ({
      userName: state.crm.users.userData.fullName,
      contactId: state.crm.users.userData.id,
      channelsOptions: state.crm.wazzup.channels,
      phone: state.crm.users.userData.phone,
    }),
    {
      sendMessageByWazzup: data => sendMessageByWazzup.request(data),
      getWazzupChannels: () => getWazzupChannels.request(),
    }
  ),
  reduxForm({
    form: 'crm-send-message-by-wazzup',
    onSubmitSuccess: (result, dispatch, props) => {
      props.onRequestClose();
    },
  })
)(CrmSendMessageByWazzupForm);
export { CrmSendMessageByWazzupForm };
